import Icon from '@root/components/Icon';
import { PageComponent } from '@root/pages/Type';
import classNames from 'classnames';
import { createRef } from 'react';

type ResourceIconProps = {
    name: string;
    size: number;
    className?: string;
    active?: boolean;
};

const DummyWrapper: PageComponent<{ className?: string }> = ({
    className,
    children,
}) => (
    <div className={classNames(className)}>
        {children}
    </div>
);

const ResourceIcon: PageComponent<ResourceIconProps> = ({
    name,
    className,
    active = false,
}) => {
    const nodeRef = createRef<HTMLDivElement>();
    let srcName = name.toLowerCase();
    let Wrapper: any = DummyWrapper;
    let wrapperClasss = '';
    switch (name.toLowerCase()) {
        case 'ip': {
            // if (size > 5) {
            //     size = 1;
            // }
            // if (size == 1) {
            //     className = classNames(className, styles.ipx1);
            //     Wrapper = SmallIconWrapper;
            // }
            // srcName = `ipx${size}`;
            srcName = `ip`;
            break;
        }
        case 'ssd':
        case 'storage': {
            srcName = `storage`;
            break;
        }
    }
    let realName = srcName;
    if (active) {
        realName += '-active';
    }
    // TODO: The default value must be maybe different then just plaintext?
    return (
        <Wrapper className={wrapperClasss}>
            <Icon
                ref={nodeRef}
                src={`/static/img/icons/resources/${realName}.svg`}
                className={className}
            />
        </Wrapper>
    );
};

export default ResourceIcon;
